import React from "react";
import Fab from "@mui/material/Fab";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { openChat, selectChatOpen } from "./chatSlice";

export function ChatLauncherFab() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectChatOpen);

  if (isOpen) return null;

  return (
    <Fab
      aria-label="Ask TripleP"
      onClick={() => dispatch(openChat())}
      sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1200 }}
    >
      💬
    </Fab>
  );
}
